<template>
    <div>
        <div class="mb-6 -mt-4">
            <h1>Final Confirmations &amp; Submission</h1>
        </div>

        <div class="mb-6">
            <h2>
                In order to submit your application, we require certain confirmations, acknowledgements and agreements
                from you as set out below. Please read these carefully and provide these confirmations by ticking the box alongside each statement and clicking
                "Accept & Confirm" where indicated below:
            </h2>
        </div>

        <ValidationObserver ref="declarationObserver">
            <div class="mb-6">
                <p>I declare and confirm the following:</p>
                <div class="mb-2">
                    <CheckboxComponent
                        id="confirm_correct_details"
                        name="confirm_correct_details"
                        label="By submitting this application, I confirm that all information provided by me, and all confirmations
                    given by me, as part of this application are true and correct in all material respects. I agree to
                    inform AMT Futures Limited promptly in writing upon any change to the information I have provided."
                        v-model="declaration.confirm_correct_details"
                        @change="updateDeclaration"
                    />
                </div>
                <div class="mb-2">
                    <CheckboxComponent
                        id="confirm_understand_policies_and_disclosures"
                        name="confirm_understand_policies_and_disclosures"
                        label="I confirm that I have read and understood the information provided under Important Policies &amp;
                    Disclosures and that AMT Futures may execute my orders outside a Regulated Market, Multilateral
                    Trading Facility or Organised Trading Facility."
                        v-model="declaration.confirm_understand_policies_and_disclosures"
                        @change="updateDeclaration"
                    />
                </div>
                <div class="mb-2">
                    <CheckboxComponent
                        id="agree_to_client_agreement"
                        name="agree_to_client_agreement"
                        label="If AMT Futures Limited accept my application, I agree to be bound by the Client Agreement and the
                    other terms and documents referred to in it. I acknowledge and accept that the information provided
                    by AMT Futures Limited in this application process will constitute part of the agreement between me
                    and AMT Futures Limited if AMT Futures Limited accept my application."
                        v-model="declaration.agree_to_client_agreement"
                        @change="updateDeclaration"
                    />
                </div>
                <div class="mb-2">
                    <CheckboxComponent
                        id="confirm_receive_provided_services"
                        name="confirm_receive_provided_services"
                        label=" I acknowledge and accept that, by submitting this application, I am making an offer to AMT Futures
                    to receive services provided by AMT Futures Limited. I acknowledge that my submission of this
                    application does not create any legal obligation of AMT Futures to provide any services to me."
                        v-model="declaration.confirm_receive_provided_services"
                        @change="updateDeclaration"
                    />
                </div>
                <div class="mb-6">
                    <CheckboxComponent
                        id="agree_personal_data_processing"
                        name="agree_personal_data_processing"
                        label="I agree to the processing of my special personal data as described in the Platform Privacy Policy
                    for the purposes described in that policy."
                        v-model="declaration.agree_personal_data_processing"
                        @change="updateDeclaration"
                    />
                </div>
            </div>
            <div class="mb-6">
                This form and the information set out in it will constitute part of the agreement between the Client and
                AMT Futures Limited.
            </div>
            <div class="mb-6">
                This form constitutes the Client's offer to AMT Futures Limited to receive the services provided by AMT
                Futures Limited.
            </div>

            <div class="mb-6">
                <ConfirmationComponent
                    id="declaration_confirmation"
                    v-model="declaration.declaration_confirmation"
                    @change="updateDeclaration"
                    name="declaration_confirmation"
                    text="AMT Futures Limited will confirm acceptance of the offer."
                    label="Accept &amp; Confirm"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import stepperValidationService from "@services/stepperValidationService";

export default {
    name: "DeclarationsFormComponent",
    props: {},
    components: {
        ValidationObserver,
    },
    props: {
        step: { default: "" },
    },
    computed: {
        ...mapGetters(["declarationState"]),
    },
    data: function () {
        return {
            declaration: {},
            isFormValidated: false,
        };
    },
    methods: {
        ...mapActions(["doGetDeclaration", "doUpdateDeclaration"]),
        updateDeclaration() {
            this.doUpdateDeclaration(this.declaration);
        },
        doValidateForm() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.declaration,
                this.$refs.declarationObserver,
                false,
                true
            );
        },
    },
    mounted() {
        this.$root.$on("submittingApplication", () => this.doValidateForm());
        this.$root.$on("stepChanged", (step) => {
            if (this.step < step && !this.isFormValidated) {
                this.doValidateForm();
                this.isFormValidated = true;
            } else if (this.step == step) {
                this.isFormValidated = false;
            }
        });

        this.doGetDeclaration().then((response) => this.declaration = response);

        this.$gtm.trackView('Declarations', 'currentPath');
    },
    watch: {
        declaration() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.declaration,
                this.$refs.declarationObserver
            );
        },
    },
};
</script>
